import { useCallback, useEffect, useState } from 'react'

// Same localStorage key and semantics as app/static/js/sidebar_state.js
// (string 'true'/'false', default collapsed) and the same `data-sidebar`
// attribute on <html> the legacy CSS keys off — kept in sync here in case
// any not-yet-ported legacy page/style still reads it during the
// incremental migration.
const STORAGE_KEY = 'vp_sidebar_expanded'

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function useSidebarState() {
  const [expanded, setExpandedState] = useState(readStored)

  useEffect(() => {
    document.documentElement.setAttribute('data-sidebar', expanded ? 'expanded' : 'collapsed')
  }, [expanded])

  const setExpanded = useCallback((value: boolean) => {
    setExpandedState(value)
    try {
      localStorage.setItem(STORAGE_KEY, String(value))
    } catch {
      // Persistence is a convenience; the toggle still works for this view.
    }
  }, [])

  const toggle = useCallback(() => setExpanded(!expanded), [expanded, setExpanded])

  return { expanded, toggle }
}
